<h1 mat-dialog-title>修改密码</h1>

<div mat-dialog-content class="content">
  <mat-form-field appearance="outline">
    <mat-label>新密码</mat-label>
    <input
      matInput
      placeholder="请输入新密码"
      [(ngModel)]="password1"
      type="password"
    />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>密码确认</mat-label>
    <input
      matInput
      placeholder="请重新输入密码"
      [(ngModel)]="password2"
      type="password"
    />
  </mat-form-field>
</div>

<div mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>取消</button>
  <button
    class="confirm"
    mat-flat-button
    color="primary"
    (click)="onOk()"
    [disabled]="loading"
  >
    确认
  </button>
</div>
